import { StyleObject } from '../types/types';

export function formatTime(time: string, shortenSmallScreen: boolean) {
  const parsedTime = new Date(time);
  if (screen.width < 600 && shortenSmallScreen) {
    return (
      twoDigitNumber(parsedTime.getHours()) +
      ':' +
      twoDigitNumber(parsedTime.getMinutes()) +
      ':' +
      twoDigitNumber(parsedTime.getSeconds())
    );
  }
  return (
    twoDigitNumber(parsedTime.getHours()) +
    ':' +
    twoDigitNumber(parsedTime.getMinutes()) +
    ':' +
    twoDigitNumber(parsedTime.getSeconds()) +
    ' ' +
    twoDigitNumber(parsedTime.getDate()) +
    '-' +
    twoDigitNumber(parsedTime.getMonth() + 1) +
    '-' +
    parsedTime.getFullYear()
  );
}

export function formatTimeOnly(time: string) {
  const parsedTime = new Date(time);
  return (
    twoDigitNumber(parsedTime.getHours()) +
    ':' +
    twoDigitNumber(parsedTime.getMinutes()) +
    ':' +
    twoDigitNumber(parsedTime.getSeconds())
  );
}

export function formatHourMinute(time: string) {
  const parsedTime = new Date(time);
  return (
    twoDigitNumber(parsedTime.getHours()) +
    ':' +
    twoDigitNumber(parsedTime.getMinutes())
  );
}

export function formatDateTime(date: Date) {
  return (
    `${date.getFullYear()}-${twoDigitNumber(
      date.getMonth() + 1,
    )}-${twoDigitNumber(date.getDate())}T` +
    twoDigitNumber(date.getHours()) +
    ':' +
    twoDigitNumber(date.getMinutes())
  );
}

export function formatDate(time: string) {
  const parsedTime = new Date(time);
  if (parsedTime.getFullYear() === 1) {
    return '';
  }

  return (
    twoDigitNumber(parsedTime.getDate()) +
    '-' +
    twoDigitNumber(parsedTime.getMonth() + 1) +
    '-' +
    parsedTime.getFullYear()
  );
}

export function formatJSDate(date: Date) {
  return (
    twoDigitNumber(date.getDate()) +
    '-' +
    twoDigitNumber(date.getMonth() + 1) +
    '-' +
    date.getFullYear()
  );
}

export function formatDateInput(time: string) {
  const parsedTime = new Date(time);
  return (
    parsedTime.getFullYear() +
    '-' +
    twoDigitNumber(parsedTime.getMonth() + 1) +
    '-' +
    twoDigitNumber(parsedTime.getDate())
  );
}

export function twoDigitNumber(number: number): string {
  const stringifiedNumber = number.toString();
  return ('0' + stringifiedNumber).slice(-2);
}

const RetourOrderStatusCreated = 'created';
const RetourOrderStatusReadyToCheck = 'ready-to-check';
const RetourOrderStatusBeingChecked = 'being-checked';
const RetourOrderStatusApproved = 'approved';
const RetourOrderStatusProcessed = 'processed';

export {
  RetourOrderStatusCreated,
  RetourOrderStatusReadyToCheck,
  RetourOrderStatusBeingChecked,
  RetourOrderStatusApproved,
  RetourOrderStatusProcessed,
};

export function convertRetourOrderStatusToReadable(status: string): string {
  switch (status) {
    case RetourOrderStatusCreated:
      return 'Aangemaakt';
    case RetourOrderStatusReadyToCheck:
      return 'Controle';
    case RetourOrderStatusBeingChecked:
      return 'Wordt gecontroleerd';
    case RetourOrderStatusApproved:
      return 'Goedgekeurd';
    case RetourOrderStatusProcessed:
      return 'Verwerkt';
    default:
      return '';
  }
}

export function convertReadableToRetourOrderStatus(status: string): string {
  switch (status) {
    case 'Aangemaakt':
      return RetourOrderStatusCreated;
    case 'Controle':
      return RetourOrderStatusReadyToCheck;
    case 'Wordt gecontroleerd':
      return RetourOrderStatusBeingChecked;
    case 'Goedgekeurd':
      return RetourOrderStatusApproved;
    case 'Verwerkt':
      return RetourOrderStatusProcessed;
    default:
      return '';
  }
}

const StockCountStatusCreated = 'created';
const StockCountStatusBeingProcessed = 'being-processed';
const StockCountStatusProcessed = 'processed';

export {
  StockCountStatusCreated,
  StockCountStatusBeingProcessed,
  StockCountStatusProcessed,
};

export function convertStockCountStatusToReadable(status: string): string {
  switch (status) {
    case StockCountStatusCreated:
      return 'Aangemaakt';
    case StockCountStatusBeingProcessed:
      return 'Wordt verwerkt';
    case StockCountStatusProcessed:
      return 'Verwerkt';
    default:
      return 'Status onbekend';
  }
}

export function convertReadableToStockCountStatus(status: string): string {
  switch (status) {
    case 'Aangemaakt':
      return StockCountStatusCreated;
    case 'Wordt verwerkt':
      return StockCountStatusBeingProcessed;
    case 'Verwerkt':
      return StockCountStatusProcessed;
    default:
      return 'Status onbekend';
  }
}

const EmailStatusCreated = 1;
const EmailStatusFailed = 2;
const EmailStatusSent = 3;

export { EmailStatusCreated, EmailStatusFailed, EmailStatusSent };
export function convertEmailStatusToReadable(status: number): string {
  switch (status) {
    case EmailStatusCreated:
      return 'In de wachtrij';
    case EmailStatusFailed:
      return 'Verzenden mislukt';
    case EmailStatusSent:
      return 'Verzonden';
    default:
      return 'Status onbekend';
  }
}
const BookingStatusInProgress = 1;
const BookingStatusPending = 2;
const BookingStatusBeingChecked = 3;
const BookingStatusFailed = 4;
const BookingStatusCompleted = 5;
const BookingStatusUnknown = 999;

export {
  BookingStatusInProgress,
  BookingStatusPending,
  BookingStatusBeingChecked,
  BookingStatusFailed,
  BookingStatusCompleted,
  BookingStatusUnknown,
};

export function converBookingStatusToReadable(status: number): string {
  if (status == undefined) {
    return 'Afboek status onbekend';
  }
  switch (status) {
    case BookingStatusInProgress:
      return 'Order wordt afgeboekt';
    case BookingStatusPending:
      return 'In de wachtrij';
    case BookingStatusBeingChecked:
      return 'Afboeken wordt gecontroleerd';
    case BookingStatusFailed:
      return 'Afboeken mislukt';
    case BookingStatusCompleted:
      return 'Afboeken afgerond';
    case BookingStatusUnknown:
      return 'Afboek status onbekend';
    default:
      console.warn('unknown status int', status);
      return 'Afboek status onbekend';
  }
}

const PickupOrderStatusInitState = 0;
const PickupOrderStatusReadyToBeProcessed = 1;
const PickupOrderStatusInitStateInProgress = 2;
const PickupOrderStatusReadyForPickUp = 3;
const PickupOrderStatusStartLoading = 4;
const PickupOrderStatusStartLoadingInProgress = 5;
const PickupOrderStatusBeingLoaded = 6;
const PickupOrderStatusLoadingDone = 7;
const PickupOrderStatusBooked = 8;
const PickupOrderStatusPackageReceiptCreated = 9;
const PickupOrderStatusPackageReceiptBeingSend = 10;
const PickupOrderStatusPackageReceiptSent = 11;
const PickupOrderStatusToBeRemoved = 100;
const PickupOrderStatusBeingRemoved = 101;
const PickupOrderStatusRemoved = 102;
const PickupOrderStatusManualActionRequired = 999;
const PickupOrderStatusOnCall = -1;

export {
  PickupOrderStatusInitState,
  PickupOrderStatusReadyToBeProcessed,
  PickupOrderStatusInitStateInProgress,
  PickupOrderStatusReadyForPickUp,
  PickupOrderStatusStartLoading,
  PickupOrderStatusStartLoadingInProgress,
  PickupOrderStatusBeingLoaded,
  PickupOrderStatusLoadingDone,
  PickupOrderStatusBooked,
  PickupOrderStatusPackageReceiptCreated,
  PickupOrderStatusPackageReceiptBeingSend,
  PickupOrderStatusPackageReceiptSent,
  PickupOrderStatusToBeRemoved,
  PickupOrderStatusBeingRemoved,
  PickupOrderStatusRemoved,
  PickupOrderStatusManualActionRequired,
  PickupOrderStatusOnCall,
};

export function converStatusToReadable(status: number): string {
  if (status == undefined) {
    return '';
  }
  switch (status) {
    case PickupOrderStatusInitState:
      return 'Ingevoerd';
    case PickupOrderStatusReadyToBeProcessed:
      return 'Kan worden klaargezet';
    case PickupOrderStatusInitStateInProgress:
      return 'Wordt klaargezet';
    case PickupOrderStatusReadyForPickUp:
      return 'Klaargezet';
    case PickupOrderStatusStartLoading:
      return 'Start laden';
    case PickupOrderStatusStartLoadingInProgress:
      return 'Start laden opgepakt';
    case PickupOrderStatusBeingLoaded:
      return 'Wordt geladen';
    case PickupOrderStatusLoadingDone:
      return 'Afboeken';
    case PickupOrderStatusBooked:
      return 'Afboeken';
    case PickupOrderStatusPackageReceiptCreated:
      return 'Pakbon aangemaakt';
    case PickupOrderStatusPackageReceiptBeingSend:
      return 'Pakbon verzonden';
    case PickupOrderStatusPackageReceiptSent:
      return 'Pakbon verzonden';
    case PickupOrderStatusToBeRemoved:
      return 'Kan opgeruimd';
    case PickupOrderStatusBeingRemoved:
      return 'Wordt opgeruimd';
    case PickupOrderStatusRemoved:
      return 'Opgeruimd';
    case PickupOrderStatusManualActionRequired:
      return 'Handmatige actie vereist';
    case PickupOrderStatusOnCall:
      return 'Op afroep';
    default:
      console.warn('unknown status int', status);
      return 'unknown status';
  }
}

export function converPickOrderStatusToInt(status: string): number[] {
  switch (status) {
    case 'Ingevoerd':
      return [PickupOrderStatusInitState];
    case 'Kan worden klaargezet':
      return [PickupOrderStatusReadyToBeProcessed];
    case 'Wordt klaargezet':
      return [PickupOrderStatusInitStateInProgress];
    case 'Klaargezet':
      return [PickupOrderStatusReadyForPickUp];
    case 'Start laden':
      return [PickupOrderStatusStartLoading];
    case 'Start laden opgepakt':
      return [PickupOrderStatusStartLoadingInProgress];
    case 'Wordt geladen':
      return [PickupOrderStatusBeingLoaded];
    case 'Afboeken':
      return [PickupOrderStatusLoadingDone, PickupOrderStatusBooked];
    case 'Pakbon aangemaakt':
      return [PickupOrderStatusPackageReceiptCreated];
    case 'Pakbon verzonden':
      return [
        PickupOrderStatusPackageReceiptBeingSend,
        PickupOrderStatusPackageReceiptSent,
      ];
    case 'Kan opgeruimd':
      return [PickupOrderStatusToBeRemoved];
    case 'Wordt opgeruimd':
      return [PickupOrderStatusBeingRemoved];
    case 'Opgeruimd':
      return [PickupOrderStatusRemoved];
    case 'Handmatige actie vereist':
      return [PickupOrderStatusManualActionRequired];
    case 'Op afroep':
      return [PickupOrderStatusOnCall];
    default:
      console.warn('unknown pick order status string', status);
      return [0];
  }
}

const TemplateTypePDF = 1;
const TemplateTypeEmail = 2;

export { TemplateTypePDF, TemplateTypeEmail };

export function converTemplateTypeToReadable(type: number): string {
  if (type == undefined) {
    return '';
  }
  switch (type) {
    case TemplateTypePDF:
      return 'PDF Template';
    case TemplateTypeEmail:
      return 'Email Template';
    default:
      console.warn('unknown template type int', status);
      return 'unknown template type';
  }
}

type JWTBody = {
  scope: string[];
};

export function hasScope(token: string, scope: string): boolean {
  const jwtBody = parseJwt(token);
  for (let i = 0; i < jwtBody.scope.length; i++) {
    if (jwtBody.scope[i] == scope) {
      return true;
    }
  }
  return false;
}

function parseJwt(token: string): JWTBody {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

const ProductStockTypeStock = 1;
const ProductStockTypeOnRequest = 2;

export { ProductStockTypeStock, ProductStockTypeOnRequest };

const StockStatusInStock = 1;
const StockStatusLimited = 2;
const StockStatusOutOfStock = 3;

export { StockStatusInStock, StockStatusLimited, StockStatusOutOfStock };

export function converStockStatusToInt(status: string): number {
  switch (status) {
    case 'Op voorraad':
      return StockStatusInStock;
    case 'Voorraad beperkt':
      return StockStatusLimited;
    case 'Uitverkocht':
      return StockStatusOutOfStock;
    default:
      console.warn('unknown stock status string', status);
      return 0;
  }
}

export function converStockStatusToReadable(status: number): string {
  switch (status) {
    case StockStatusInStock:
      return 'Op voorraad';
    case StockStatusLimited:
      return 'Voorraad beperkt';
    case StockStatusOutOfStock:
      return 'Uitverkocht';
    default:
      console.warn('unknown stock status number', status);
      return 'Uitverkocht';
  }
}

export function arraysEqual(a: string[], b: string[]) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) {
    return false;
  }

  // If you don't care about the order of the elements inside
  // the array, you should sort both arrays here.
  // Please note that calling sort on an array will modify that array.
  // you might want to clone your array first.

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}

export function setBodyStyleObject(object: StyleObject): void {
  Object.keys(object).forEach((k: string) => {
    window.document.body.style.setProperty(k, object[k]);
  });
}

export function roundUnitNumbers(inUnits: number): number {
  if (isNaN(inUnits)) {
    return 0;
  }
  if (!inUnits) {
    return 0;
  }

  return Math.round(inUnits * 1000) / 1000;
}
